"use client";

import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react";

import { cn } from "@hero-app/lib/utils";
import type { SortDirection } from "./table-data";

export function SortableHeader({
  label,
  active,
  direction,
  onSort,
}: {
  label: string;
  active: boolean;
  direction: SortDirection;
  onSort: () => void;
}) {
  const SortIcon = active ? (direction === "asc" ? ChevronUp : ChevronDown) : ChevronsUpDown;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onSort();
      }}
      className={cn(
        "inline-flex items-center gap-1 text-left text-[11px] transition-colors",
        active ? "text-black/50" : "text-black/30 hover:text-black/40",
      )}
    >
      {label}
      <SortIcon className={cn("size-2.5 shrink-0", !active && "opacity-70")} />
    </button>
  );
}
